exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".highlight:not(.djs-connection) .djs-visual > :nth-child(1) {\n  fill: lightgreen !important;\n  fill-opacity: 0.7 !important;\n}\n.highlight.djs-connection .djs-visual > :nth-child(1) {\n  stroke: lightgreen !important;\n  stroke-opacity: 1.0 !important;\n}\n.input-group {\n  margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./App/Components/TTSBar/tts-bar.less
// module id = 303
// module chunks = 0